import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { baseClassName } from './text.utils.js';

/**
 * Non-truncating Text element. Used for the common case where `truncate` is unset, avoiding
 * the truncation / tooltip hook overhead.
 */
// eslint-disable-next-line react/display-name -- internal helper, not exposed in public API
const PlainText = forwardRef(({ as, variant, color = 'inherit', align, italic, underline, strikethrough, className, ...props }, ref) => {
    const Element = as;
    return (jsx(Element, { "data-fpl-component": "", ...props, ref: ref, className: baseClassName({ variant, color, align, italic, underline, strikethrough }, className) }));
});

export { PlainText };
//# sourceMappingURL=text.plain.js.map
